"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PrescriptionPillSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path fill-rule="evenodd" d="M27.37 8.502a6.004 6.004 0 0 1-1.471 6.086L14.592 25.895A6.004 6.004 0 1 1 6.1 17.404L17.408 6.097c.077-.078.156-.153.237-.225l.01-.01a6.005 6.005 0 0 1 9.715 2.64zm-14.909 5.37-4.946 4.946a4.004 4.004 0 1 0 5.663 5.663l4.946-4.947-5.663-5.663zm9.906-5.651a1 1 0 0 1 1.414 0c1.248 1.247 1.012 3.23-.177 4.42l-2.651 2.65a1 1 0 1 1-1.415-1.414l2.652-2.651c.569-.569.491-1.277.177-1.591a1 1 0 0 1 0-1.414z" clip-rule="evenodd" stroke="none"></path>';
var PrescriptionPillSVG = function PrescriptionPillSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.PrescriptionPillSVG = PrescriptionPillSVG;
PrescriptionPillSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(PrescriptionPillSVG);
exports.default = _default;